import React, { Fragment, useEffect, useState } from 'react'
import { Row, Col, Button } from "reactstrap";
import { useNavigate, useParams } from 'react-router-dom';

import SideBar from "../../components/SideBar";
import { getOneOperationApi } from "../../api/operationManagemment"

import { IoArrowBack } from "react-icons/io5";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import logo from './../../assets/img/logo/logo.png';

function formatDateTime(value) {
    const d = new Date(value)

    if (isNaN(d.getTime())) {
        return '—'
    }

    return d.toLocaleString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

function MissionOrder() {
    const { missionOrderID } = useParams()
    const navigate = useNavigate()

    const [operation, setOperation] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [hasError, setHasError] = useState(false)
    const [isExporting, setIsExporting] = useState(false)

    useEffect(() => {
        getInitialValue()
        // eslint-disable-next-line
    }, [missionOrderID])

    const getInitialValue = async () => {
        try {
            setIsLoading(true)
            setHasError(false)

            const response = await getOneOperationApi(missionOrderID)

            if (!response) {
                setHasError(true)
                return
            }

            setOperation(response)
        }
        catch(err) {
            setHasError(true)
        }
        finally {
            setIsLoading(false)
        }
    }

    const handlePrint = () => {
        window.print()
    }

    const handleDownloadMissionOrder = async () => {
        const contentElement = document.querySelector('#missionOrderPaper');
        if (!contentElement) return

        setIsExporting(true)

        try {
            const canvas = await html2canvas(contentElement, { scale: 2, backgroundColor: '#ffffff' })
            const imgData = canvas.toDataURL('image/png')

            const pdf = new jsPDF('p', 'mm', 'a4')
            const pageWidth = pdf.internal.pageSize.getWidth()
            const pageHeight = pdf.internal.pageSize.getHeight()

            let imgWidth = pageWidth
            let imgHeight = (canvas.height * imgWidth) / canvas.width

            if (imgHeight > pageHeight) {
                imgHeight = pageHeight
                imgWidth = (canvas.width * imgHeight) / canvas.height
            }

            const xOffset = (pageWidth - imgWidth) / 2

            pdf.addImage(imgData, 'PNG', xOffset, 0, imgWidth, imgHeight)
            pdf.save('ordre_de_mission.pdf')
        }
        finally {
            setIsExporting(false)
        }
    }

    const reference = operation?._id ? operation._id.slice(-8).toUpperCase() : ''

    return (
        <Fragment>
            <section className='missionOrder'>
                <Row>
                    <Col md="2" className="p-0 noPrint">
                        <SideBar />
                    </Col>
                    <Col md="10" className="p-0">
                        <div className="contents">
                            <div className="pageHeader noPrint">
                                <button type="button" className="backLink" onClick={() => navigate(-1)}>
                                    <IoArrowBack /> Retour
                                </button>
                                <span className="eyebrow">Gestion des opérations</span>
                                <h1>Ordre de mission</h1>
                            </div>

                            {isLoading && (
                                <p className="stateMessage noPrint">Chargement de l'ordre de mission…</p>
                            )}

                            {!isLoading && hasError && (
                                <p className="stateMessage error noPrint">Impossible de charger cette opération. Réessayez dans un instant.</p>
                            )}

                            {!isLoading && !hasError && operation && (
                                <Fragment>
                                    <div className="paperWrapper">
                                        <div className="paper" id="missionOrderPaper">
                                            <div className="letterhead">
                                                <img src={logo} alt="Royaume du Maroc" className="crest" />
                                                <div className="letterheadText">
                                                    <p>Royaume du Maroc</p>
                                                    <p>Ministère de l'Intérieur</p>
                                                    <p className="wilaya">Wilaya de la Région Sous-Massa</p>
                                                    <p>Préfecture d'Agadir Ida-Outanane</p>
                                                </div>
                                            </div>

                                            <div className="titleBlock">
                                                <h2>Ordre de mission</h2>
                                                {reference && <span className="reference">Réf. {reference}</span>}
                                            </div>

                                            <div className="routeBlock">
                                                <div className="routeStop">
                                                    <span className="stopLabel">Départ</span>
                                                    <span className="stopCity">{operation.startCityName}</span>
                                                    <span className="stopTime">{formatDateTime(operation.SelectedFromDate)}</span>
                                                </div>
                                                <span className="routeLine" aria-hidden="true"></span>
                                                <div className="routeStop arrival">
                                                    <span className="stopLabel">Arrivée</span>
                                                    <span className="stopCity">{operation.arrivedCityName}</span>
                                                    <span className="stopTime">{formatDateTime(operation.SelectedToDate)}</span>
                                                </div>
                                            </div>

                                            <div className="infoGrid">
                                                <div className="infoItem">
                                                    <span className="infoLabel">Conducteur</span>
                                                    <span className="infoValue">{operation.selectedConducteur?.firstName} {operation.selectedConducteur?.lastName}</span>
                                                </div>
                                                <div className="infoItem">
                                                    <span className="infoLabel">Téléphone</span>
                                                    <span className="infoValue mono">{operation.selectedConducteur?.phone || '—'}</span>
                                                </div>
                                                <div className="infoItem">
                                                    <span className="infoLabel">Véhicule</span>
                                                    <span className="infoValue">{operation.selectedModel?.marque} {operation.selectedModel?.modele}</span>
                                                </div>
                                                <div className="infoItem">
                                                    <span className="infoLabel">Immatriculation</span>
                                                    <span className="infoValue plate mono">{operation.selectedMatricule?.immatriculation || '—'}</span>
                                                </div>
                                            </div>

                                            <div className="signatureBlock">
                                                <div className="signatureItem">
                                                    <span className="signatureLine"></span>
                                                    <span className="signatureLabel">Signature du conducteur</span>
                                                </div>
                                                <div className="signatureItem">
                                                    <span className="signatureLine"></span>
                                                    <span className="signatureLabel">Visa et cachet</span>
                                                </div>
                                            </div>

                                            <p className="paperFooter">Document généré le {formatDateTime(new Date())}</p>
                                        </div>
                                    </div>

                                    <div className="pageActions noPrint">
                                        <Button className="secondaryAction" onClick={handlePrint}>Imprimer</Button>
                                        <Button className="primaryAction" onClick={handleDownloadMissionOrder} disabled={isExporting}>
                                            {isExporting ? 'Génération…' : 'Télécharger le PDF'}
                                        </Button>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                    </Col>
                </Row>
            </section>
        </Fragment>
    )
}

export default MissionOrder
